import type { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string;
  icon: LucideIcon;
  colorClass: string;
  tooltip?: string;
}

export function MetricCard({
  title,
  value,
  icon: Icon,
  colorClass,
  tooltip,
}: MetricCardProps) {
  return (
    <div
      className="bg-gray-900 border border-gray-800 rounded-xl p-5 transition-colors duration-200 hover:border-gray-700"
      title={tooltip}
    >
      <div className="flex items-center gap-4">
        <div
          className={`flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center ${colorClass}`}
        >
          <Icon className="w-5 h-5" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider">
            {title}
          </p>
          <p className="mt-0.5 text-2xl font-bold text-gray-100 truncate">
            {value}
          </p>
        </div>
      </div>
    </div>
  );
}
